import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/AuthModal.css';

const AuthModal = ({ isOpen, onClose, message = "You must be logged in to perform this action" }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  if (!isOpen) return null;

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal">
        <div className="auth-modal-content">
          <div className="auth-modal-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#E67E42" strokeWidth="2">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
              <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
            </svg>
          </div>
          
          <h2 className="auth-modal-title">Login Required</h2>
          
          <p className="auth-modal-message">
            {message}
          </p>
          
          <div className="auth-modal-buttons">
            <button 
              className="auth-modal-btn auth-modal-btn-primary" 
              onClick={handleLogin}
            >
              Login
            </button>
            
            <button 
              className="auth-modal-btn auth-modal-btn-secondary" 
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;